import { FC } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Card, Badge } from 'react-bootstrap';
import { FaChartPie } from 'react-icons/fa';

ChartJS.register(ArcElement, Tooltip, Legend);

interface Props {
  pieData: any;
}

const PieChartComponent: FC<Props> = ({ pieData }) => {
  if (!pieData) return null;

  return (
    <Card 
      style={{ backgroundColor: '#2d2d2d', borderColor: '#444' }} 
      className="h-100"
    >
      <Card.Body className="d-flex flex-column">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h5 className="mb-0 text-light">
            <FaChartPie className="me-2" />
            Conversations by Source
          </h5>
          <Badge bg="secondary">
            {pieData.datasets[0]?.data?.reduce((a: number, b: number) => a + b, 0) || 0} total
          </Badge>
        </div>
        
        <div className="flex-grow-1 d-flex align-items-center justify-content-center">
          <div style={{ width: '100%', height: '300px' }}>
            <Pie 
              data={pieData} 
              options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    position: 'bottom' as const,
                    labels: {
                      color: '#ffffff',
                      padding: 20,
                      usePointStyle: true,
                      pointStyle: 'circle'
                    }
                  },
                  tooltip: {
                    backgroundColor: '#1a1a1a',
                    titleColor: '#ffffff',
                    bodyColor: '#ffffff',
                    borderColor: '#444',
                    borderWidth: 1
                  }
                }
              }}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default PieChartComponent;